import App from './App.svelte';

const formApp = new App({
    target: document.getElementById('form-app-popup-review'),
});

export default formApp;

const event = new CustomEvent('formReviewAppReady', {detail: formApp});

document.dispatchEvent(event);
